export default __webpack_public_path__ + "static/media/Epoly.0277c8f0.xlsx";